import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonGroupModule } from 'primeng/buttongroup';
import { TooltipModule } from 'primeng/tooltip';
import { ButtonConfirmComponent } from '../button-confirm/button-confirm.component';
import { ButtonIconComponent } from '../button-icon/button-icon.component';

export interface ActionButtonGroupOption {
    id: string;
    icon: string;
    tooltip?: string;
    ariaLabel?: string;
    severity: 'success' | 'warn' | 'danger' | 'primary' | 'secondary';
    isVisible: boolean;
    rounded?: boolean;
    isLoading?: boolean;
    hasConfirmation?: boolean;
    confirmationMessage?: string;
    confirmationAcceptLabel?: string;
    confirmationAcceptLabelStyleClass?: string;
    confirmationRejectLabel?: string;
    onClick: () => void;
}
@Component({
    selector: 'actions-button-group',
    standalone: true,
    imports: [ButtonGroupModule, TranslateModule, TooltipModule, ButtonIconComponent, ButtonConfirmComponent],
    templateUrl: './actions-button-group.component.html',
    styleUrl: './actions-button-group.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionsButtonGroupComponent {
    options = input.required<ActionButtonGroupOption[]>();
    itemId = input.required<string | number>();

    size = input<undefined | 'small' | 'large'>(undefined);
    outlined = input<boolean>(false);
    disabled = input<boolean>(false);

    visibleOptions = computed(() => this.options().filter(option => option.isVisible));
}
